import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/brand";

/* Header used on auth + application sub-pages: Home back-link + centered logo + right tag */
export default function AuthHeader({ tag = "SECURE LOGIN", backTo = "/" }) {
  return (
    <header className="border-b border-gray-200 bg-white">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to={backTo} data-testid="auth-home-link" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#0a0a0a] transition-colors">
          <ArrowLeft className="h-4 w-4" /> Home
        </Link>
        <Logo />
        <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400">{tag}</span>
      </div>
    </header>
  );
}
